import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { Station, toTimestamp } from '@mi-front/core';
import { LowerthirdType } from '../../screens/global-reports/lowerthird/types';
import { PlayButtonP } from './PlayButton';

export function PlayLowerthirdButton(p: { lowerthird: LowerthirdType; station: Station }) {
  const play = usePlaybackPlay();

  const handlePlay = () => {
    const startTs = toTimestamp(p.lowerthird.from);
    const stopTs = toTimestamp(p.lowerthird.to);

    play({
      startTs,
      stopTs,
    });
  };

  return <PlayButtonP play={handlePlay} />;
}
